export default {
  props: {
    data: {
      required: true
    },
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    list: function list() {
      return this.data.vActList;
    }
  },
  filters: {
    pic: function pic(item, picSize) {
      return item.tPicList.mpList['pic_' + picSize];
    }
  }
};